export function roundCurrencyAmount(value: number): number {
  const normalizedValue = Number(value);
  if (!Number.isFinite(normalizedValue)) {
    return 0;
  }
  return Math.round(normalizedValue * 100) / 100;
}

export function calculateProratedAllowanceAmount(
  monthlyAmount: number,
  referenceDate: Date = new Date(),
): number {
  const fullAmount = roundCurrencyAmount(monthlyAmount);
  if (fullAmount <= 0) {
    return 0;
  }

  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth();
  const dayOfMonth = referenceDate.getDate();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const remainingDays = Math.max(daysInMonth - dayOfMonth + 1, 0);

  return roundCurrencyAmount((fullAmount * remainingDays) / daysInMonth);
}
